import React from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Download } from 'lucide-react';
import * as XLSX from 'xlsx';

const B2BProductUploadTemplate: React.FC = () => {
  const downloadTemplate = () => {
    const template = [
      {
        'Name': 'Tomatoes Premium',
        'Price': 25.50,
        'Unit': 'kg',
        'Description': 'Premium quality tomatoes',
        'Tags': 'fresh, premium, vegetables',
        'Weight': 1.0,
        'Purchase Price per KG': 20.00,
        'Spoilage Rate': 5.0,
        'Cost Notes': 'Seasonal pricing applies'
      }
    ];

    const ws = XLSX.utils.json_to_sheet(template);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'B2B Products Template');
    XLSX.writeFile(wb, 'b2b_products_template.xlsx');
  };

  return (
    <div className="flex items-center justify-between">
      <div>
        <Label>Excel File</Label>
        <p className="text-sm text-muted-foreground">
          Upload an Excel file with columns: Name, Price, Unit, Description (optional), Tags (optional), Weight (optional), Purchase Price per KG (optional), Spoilage Rate (optional), Cost Notes (optional)
        </p>
      </div>
      <Button
        variant="outline"
        onClick={downloadTemplate}
        className="flex items-center gap-2"
      >
        <Download className="h-4 w-4" />
        Download Template
      </Button>
    </div>
  );
};

export default B2BProductUploadTemplate;